module.exports = __webpack_public_path__ + "static/media/YM81_5.cbcfbc1e.jpg";